import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { INameId } from '@modeso/types__aumico-lib-core-be';
import { TranslatedChecklist } from '../../interfaces/checklists';

@Component({
    selector: 'aumico-add-edit-checklist',
    templateUrl: './add-edit-checklist.component.html',
    styleUrls: ['./add-edit-checklist.component.scss'],
})
export class AddEditChecklistComponent {
    public checklistForm: FormGroup;

    @Input() hasFlis = false;
    @Input() flis: INameId[];

    @Input() checklist: TranslatedChecklist;

    @Output() onSubmitChecklistForm = new EventEmitter<Partial<TranslatedChecklist>>();
    @Output() onCancelCheckList = new EventEmitter<void>();

    constructor() {}

    onSubmit(checklist: Partial<TranslatedChecklist>): void {
        this.onSubmitChecklistForm.emit(checklist);
    }

    onCancel(): void {
        this.onCancelCheckList.emit();
    }
}
